// 수학 출제하기의 비율 칸(2026-11-05 대표: "퍼센트를 심플하게 네모 칸에 하 10 · 중 20 · 상 70 이런 식으로, 100 안 되면 그 비율대로").
// 칸마다 숫자를 적는다. 비워 두면 0. 합이 100 이 아니면 적은 비율대로 100 에 맞춰 나눈다(5% 단위, 서버 math_bank.ratio_of 와 같은 셈).
// 모두 비우면 비율 없이 뽑는다. 서버로는 difficulty_ratio · unit_ratio · skill_ratio 로 간다(수학 사이트 8절).
import React from "react";

export const DIFFICULTY_LIST = ["최하", "하", "중", "상", "최상"];
const STEP = 5;

// 적은 값을 5% 단위 합 100 으로. 끝수는 나머지가 큰 칸부터. 합이 0 이면 null(비율 없음)
export const normalizedRatioOf = (ratio, keyList) => {
  const valueList = keyList.map((key) => Math.max(0, Number(ratio[key]) || 0));
  const sum = valueList.reduce((total, one) => total + one, 0);
  if (!sum) return null;
  const unitCount = 100 / STEP;
  const exactList = valueList.map((one) => (one * unitCount) / sum);
  const unitList = exactList.map(Math.floor);
  let rest = unitCount - unitList.reduce((total, one) => total + one, 0);
  exactList
    .map((_, index) => index)
    .sort((left, right) => exactList[right] - unitList[right] - (exactList[left] - unitList[left]))
    .forEach((index) => {
      if (rest > 0) {
        unitList[index] += 1;
        rest -= 1;
      }
    });
  return Object.fromEntries(keyList.map((key, index) => [key, unitList[index] * STEP]));
};

// 문항 수를 비율대로 나눈 값(끝수는 나머지가 큰 쪽부터). 칸 아래 'N문항' 으로만 보여 준다
const countByKeyOf = (total, normalized, keyList) => {
  if (!normalized) return {};
  const exactList = keyList.map((key) => (total * normalized[key]) / 100);
  const countList = exactList.map(Math.floor);
  let rest = total - countList.reduce((sum, one) => sum + one, 0);
  exactList
    .map((_, index) => index)
    .sort((left, right) => exactList[right] - countList[right] - (exactList[left] - countList[left]))
    .forEach((index) => {
      if (rest > 0) {
        countList[index] += 1;
        rest -= 1;
      }
    });
  return Object.fromEntries(keyList.map((key, index) => [key, countList[index]]));
};

// isList: 대분류 · 소분류처럼 이름이 긴 칸은 한 줄에 하나씩(이름 · 칸 · 문항 수)
const MathBankRatioFields = ({ itemList, ratio, onChange, total, idPrefix, isList = false }) => {
  const keyList = itemList.map((item) => item.key);
  const normalized = normalizedRatioOf(ratio, keyList);
  const countByKey = countByKeyOf(total, normalized, keyList);
  const sum = keyList.reduce((value, key) => value + (Number(ratio[key]) || 0), 0);
  return (
    <div className="math-bank-page__ratio">
      <div className={`math-bank-page__ratio-grid${isList ? " math-bank-page__ratio-grid--list" : ""}`}>
        {itemList.map((item) => (
          <label key={item.key} className="math-bank-page__ratio-cell" htmlFor={`${idPrefix}-${item.key}`}>
            <span className="math-bank-page__ratio-name" title={item.label}>
              {item.label}
            </span>
            <input
              id={`${idPrefix}-${item.key}`}
              type="number"
              inputMode="numeric"
              min={0}
              max={100}
              className="math-bank-page__ratio-input"
              value={ratio[item.key] ?? ""}
              placeholder="0"
              onChange={(event) => {
                const text = event.target.value;
                onChange({ ...ratio, [item.key]: text === "" ? "" : Math.max(0, Math.min(100, Math.round(Number(text) || 0))) });
              }}
            />
            {normalized && <span className="math-bank-page__ratio-count">{countByKey[item.key]}문항</span>}
          </label>
        ))}
      </div>
      {normalized && sum !== 100 && (
        <div className="math-bank-page__ratio-sum">
          합 {sum} → {keyList.filter((key) => normalized[key]).map((key) => `${itemList.find((item) => item.key === key).label} ${normalized[key]}`).join(" · ")}
        </div>
      )}
    </div>
  );
};

export default MathBankRatioFields;
